// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 0.5px !important;
  --border-color: #E5E5E5;
  --border-bottom: none;
  border: none;
  margin-top: 0;
  border-radius: 0;
}
@media (min-width: 991px) {
  ion-item {
    padding-inline: 3%;
    --min-height: 45px;
  }
}
ion-item:not(:last-child) {
  margin-bottom: 20px;
}
ion-item.no-line {
  --border-color: transparent;
}
ion-item.no-background {
  --background: transparent !important;
}

@media (min-width: 991px) {
  .form-row {
    zoom: 0.88;
  }
}

ion-input {
  --border: none !important;
  color: var(--color-black);
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.privacy {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--color-black);
  text-transform: capitalize;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  margin-bottom: 0;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
  --checkbox-background-checked: #9E5F2C;
  --checkbox-background: var(--default-white);
  color: #072633;
}
.terms ion-checkbox::part(label) {
  white-space: unset;
}
.terms ion-checkbox::part(container) {
  border: 1px solid #9E5F2C;
}
@media (min-width: 991px) {
  .terms {
    padding: 0;
    position: relative;
    bottom: 5px;
  }
}

ion-checkbox {
  margin-left: 0px;
  width: auto;
}

.stacked {
  position: relative;
  top: 8px;
  left: 5%;
  z-index: 2;
}
ion-label {
  font-family: AppFont;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  background: #fff;
  color: #807D7D;
  padding: 0 5px;
}

@media (min-width: 991px) {
  .name-row {
    padding-inline: 3%;
  }
}

.name-col {
  padding: 0;
}
@media (min-width: 991px) {
  .name-col ion-item {
    padding-inline: 0;
  }
  .name-col:first-child {
    padding-right: 7px;
  }
  .name-col:last-child {
    padding-left: 7px;
  }
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--color-black);
}
.input-age ion-input:first-child {
  border-right: 1px solid #cbd5e1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #cbd5e1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

@media (max-width: 992px) {
  .wrapper {
    padding: 50px 15px 20px;
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 20px;
}
.button-wrapper ion-button {
  width: 100%;
  --background: #2D69AA;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
  }
}
.wrapper-modal ion-item {
  --background: #fff;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: Title, sans-serif;
  font-size: 35px;
  letter-spacing: 0.08em;
}
.wrapper-modal .subtitle-text {
  display: none;
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
  letter-spacing: 0.02em;
}
.wrapper-modal .header-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 20px 40px 5px;
  }
}

.underline {
  --border-width: 0px;
  border: none !important;
  color: var(--ion-color-primary);
}

.error_container {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sign-up-modal/sign-up-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;AADD;;AAIA;EACC,QAAA;EACA,kBAAA;AADD;;AAGA;EACC,gCAAA;EAEA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AADD;ACfE;EDSF;IAUE,kBAAA;IACA,kBAAA;EAAA;AACF;AAEC;EACC,mBAAA;AAAF;AAGC;EACC,2BAAA;AADF;AAGC;EACC,oCAAA;AADF;;AC9BE;EDmCF;IAEE,UAAA;EAFA;AACF;;AAKA;EACC,yBAAA;EACA,yBAAA;EACA,gCAAA;AAFD;;AAIA;EACC,kBAAA;EACA,yBAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,6BAAA;AAFD;AAIC;EACC,YAAA;EACA,yBAAA;EACA,0BAAA;AAFF;;AAMA;EACC,eAAA;EACA,mBAAA;AAHD;;AAMA;EAEC,gBAAA;AAJD;;AAOA;EACC,gBAAA;AAJD;AAKC;EACC,kBAAA;EACA,sCAAA;EACA,2CAAA;EACA,cAAA;AAHF;AAMC;EACC,kBAAA;AAJF;AAOC;EACG,yBAAA;AALJ;ACpFE;ED2EF;IAkBE,UAAA;IACA,kBAAA;IACA,WAAA;EALA;AACF;;AAQA;EACC,gBAAA;EACA,WAAA;AALD;;AAQA;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AALD;AAWA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AATD;;ACnHE;ED+HF;IAEE,kBAAA;EATA;AACF;;AAWA;EACC,UAAA;AARD;AC7HE;ED0IA;IACC,iBAAA;EAVD;EAaA;IACC,kBAAA;EAXD;EAaA;IACC,iBAAA;EAXD;AACF;;AAeC;EACC,YAAA;EACA,kBAAA;EACA,yBAAA;AAZF;AAcC;EACC,+BAAA;AAZF;AAcC;EACC,8BAAA;AAZF;;AAeA;EACC,yBAAA;EACA,gBAAA;AAZD;;AAcA;EACC,YAAA;EACA,mBAAA;AAXD;;ACxJE;EDsKF;IAEE,uBAAA;EAXA;AACF;;AAcA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;AAXD;AAYC;EACC,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAVF;ACnLE;EDwLD;IAQE,gBAAA;IACA,eAAA;EATD;AACF;AAUE;EACC,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AARH;;AAYA;EAUC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAlBD;AChME;EDqMF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;IAEA,8CAAA;EAJA;AACF;AAUC;EACC,kBAAA;AARF;AAUC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AARF;AAUC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;AARF;AAUC;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;AARF;AAUC;EACC,aAAA;AARF;AClPE;EDyPD;IAGE,sBAAA;EAND;AACF;;AASA;EACC,mBAAA;EACA,uBAAA;EACA,+BAAA;AAND;;AAQA;EACC,mBAAA;AALD","sourcesContent":["@import '../../../theme/mixins';\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n\tgap: 5px;\n\tmargin-bottom: 8px;\n}\nion-item {\n\t--border-width: 0.5px !important;\n\t// --border-radius: 52px !important;\n\t--border-color: #E5E5E5;\n\t--border-bottom: none;\n\tborder: none;\n\tmargin-top: 0;\n\tborder-radius: 0;\n\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t\t--min-height: 45px;\n\t}\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t&.no-line {\n\t\t--border-color: transparent;\n\t}\n\t&.no-background {\n\t\t--background: transparent !important;\n\t}\n}\n\n.form-row {\n\t@include desktop {\n\t\tzoom: 0.88;\n\t}\n}\n\nion-input {\n\t--border: none !important;\n\tcolor: var(--color-black);\n\tfont-family: AppFont, sans-serif;\n}\n.no-line {\n\tborder-bottom: 0px;\n\t--background: transparent;\n}\n\n.privacy {\n\tdisplay: flex;\n\talign-items: center;\n\n\tfont-size: 12px;\n\tcolor: var(--ion-color-black);\n\n\tion-button {\n\t\tpadding: 0px;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: capitalize;\n\t}\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\nion-item {\n\t// --border-radius: 5px;\n\tmargin-bottom: 0;\n}\n\n.terms {\n\tmargin-left: 0px;\n\tion-checkbox {\n\t\tmargin-right: 10px;\n\t\t--checkbox-background-checked: #9E5F2C;\n\t\t--checkbox-background: var(--default-white);\n\t\tcolor: #072633;\n\t}\n\n\tion-checkbox::part(label) {\n\t\twhite-space: unset;\n\t}\n\n\tion-checkbox::part(container) {\n  \t\tborder: 1px solid #9E5F2C;\n\t}\n\n\t@include desktop {\n\t\tpadding: 0;\n\t\tposition: relative;\n\t\tbottom: 5px;\n\t}\n}\n\nion-checkbox {\n\tmargin-left: 0px;\n\twidth: auto;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: 8px;\n\tleft: 5%;\n\tz-index: 2;\n\n\t@include desktop {\n\t\t// left: 3%;\n\t}\n}\nion-label {\n\tfont-family: AppFont;\n\tfont-size: 11px;\n\tline-height: 85%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\tbackground: #fff;\n\tcolor: #807D7D;\n\tpadding: 0 5px;\n}\n\n.name-row {\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t}\n}\n.name-col {\n\tpadding: 0;\n\t@include desktop {\n\t\t.stacked {\n\t\t\t// left: 0;\n\t\t}\n\t\tion-item {\n\t\t\tpadding-inline: 0;\n\t\t}\n\n\t\t&:first-child {\n\t\t\tpadding-right: 7px;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-left: 7px;\n\t\t}\n\t}\n}\n.input-age {\n\tion-input {\n\t\theight: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t}\n\tion-input:first-child {\n\t\tborder-right: 1px solid #cbd5e1;\n\t}\n\tion-input:last-child {\n\t\tborder-left: 1px solid #cbd5e1;\n\t}\n}\nion-footer {\n\t--background: transparent;\n\tbox-shadow: none;\n}\n.loading {\n\theight: 50vh;\n\talign-items: center;\n}\n\n.wrapper {\n\t@include mobile {\n\t\tpadding: 50px 15px 20px;\n\t}\n}\n\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding-bottom: 20px;\n\tion-button {\n\t\twidth: 100%;\n\t\t--background: #2D69AA;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\n\t\t@include desktop {\n\t\t\tmin-height: 64px;\n\t\t\tfont-size: 20px;\n\t\t}\n\t\tp {\n\t\t\tmargin-top: 5px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t\t// border: 2px solid var(--color-black);\n\t\tbox-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;\n\t}\n\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\tion-item {\n\t\t--background: #fff;\n\t}\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t}\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: Title, sans-serif;\n\t\tfont-size: 35px;\n\t\tletter-spacing: 0.08em;\n\t}\n\t.subtitle-text {\n\t\tdisplay: none;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tpadding: 10px;\n\t\tletter-spacing: 0.02em;\n\t}\n\t.header-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\tpadding: 20px 40px 5px;\n\t\t}\n\t}\n}\n.underline {\n\t--border-width: 0px;\n\tborder: none !important;\n\tcolor: var(--ion-color-primary);\n}\n.error_container {\n\tmargin-bottom: 10px;\n}\n\n@include desktop {\n\tion-button {\n\t\t// min-height: 54px !important;\n\t\t// font-size: 17px !important;\n\t\t&:hover {\n\t\t\t// --background: var(--primary-btn) !important;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
